import classNames from 'classnames'

import ExportCSVButton from './ExportCSVButton.js'
import MoneyOverTimeGraph from './MoneyOverTimeGraph.js'

/**
 * Money-over-time Pane
 *
 * @param {Object} props
 * @param {Boolean} props.isLoading
 * @param {String} props.title
 * @param {Object} props.data
 * @param {Date} props.startDate
 * @param {Date} props.endDate
 * @param {Function} props.onExport
 * @returns {React.ReactNode}
 */
export default function MoneyOverTimePane({
  isLoading,
  title,
  data,
  startDate,
  endDate,
  onExport,
}) {
  return (
    <div className="row">
      <div className="medium-12 columns">
        <div
          className={classNames('panel panel--analytics clearfix', {
            loading: isLoading,
          })}
        >
          <div className="panel__header panel__header--analytics flex--justify">
            <h3 className="subheader subheader--analytics">{title}</h3>
            {data && <ExportCSVButton onExport={onExport} />}
          </div>
          <MoneyOverTimeGraph
            data={data}
            startDate={startDate}
            endDate={endDate}
          />
        </div>
      </div>
    </div>
  )
}
